import type { FaireBrandEntity } from "../../entity_types/brand";

export const oskro: FaireBrandEntity = {
  token: "oskro",
  type: "brand",
  name: "Oskrö",
  logoUrl:
    "https://cdn.prerelease.faire.dev/fastly/92f1720de98adede92a4e1ce7abff38652be4359bc4363a724996e08cb676bc0.webp",
  description: "Premium artisanal spreads made in Brooklyn",
  rating: 4.9,
  location: "Brooklyn, NY",
  minimumOrderDollars: 150,
  tags: ["premium", "artisanal", "spreads"],
  isInsider: true,
  categoryTokens: ["cat_food-snacks"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "entity-db-bootstrap",
  },
};
